export default __webpack_public_path__ + "static/media/clientes.64e1822c.svg";